<template>
  <div class="col-md-2 col-sm-4 col-12">
    <router-link :to="routerLink" class="block-icon-link">
      <div class="block_btn">
        <img
          class="icons"
          :src="BASE_URL + 'assets/icons/' + imgName + '.png'"
        />
        <p :style="{ color: '#' + txtColor }">{{ blockTitle }}</p>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "icon-block",
  props: ["txtColor", "imgName", "routerLink", "blockTitle"]
};
</script>
